/**
 * Operations on a macro string.
 */
import ContentType from "common/enums/HttpContentType";
export default {

    /**
     * Validate a macro
     * @param macro the macro string to validate
     * @param paramType the prefix to pass - either VARIABLE (${}) or PROMPT (?{})
     * @returns {*}
     */
    validate: function(macro, paramType) {

        return $.ajax({
            url: context.path + "/webservices/rest/macros/validateWithContext",
            type: "POST",
            data: {
                macro: macro,
                paramType: paramType ? paramType : "VARIABLE"
            },
            contentType: ContentType.FORM
        });
    },

    /**
     * Get the variable references for the given macro.
     */
    getVariableReferences: function(macro) {
        return $.ajax({
            url: context.path + "/webservices/rest/macros/vars",
            type: "POST",
            data: {
                macro: macro
            },
            contentType: ContentType.FORM
        });
    },

    /**
     * Get path variable references for the given string. Parses {x} and ${x} var syntax
     */
    parsePathVariables: function(macro) {
        return $.ajax({
            url: `${context.path}/webservices/rest/macros/vars/url`,
            type: "POST",
            data: {
                macro
            },
            contentType: ContentType.FORM
        });
    },

    /**
     * Execute a macro, in a generic context, passed within each macroObject.
     *
     * @param macroObjects
     * @returns {*}
     */
    execute: function(macroObjects) {
        // Pass temp objects that do not include name and property, because the server doesn't need
        // those properties to evaluate the macros. We need to keep them in client state though,
        // in order to sync the results back up with the correct prompt fields.
        var data = [];
        $.each(macroObjects, function(i, val) {
            data.push({
                macro: val.macro,
                arguments: val.arguments
            });
        });
        return $.ajax({
            url: context.path + "/webservices/rest/macros/execute/",
            type: "POST",
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json"
        });
    }
};
